import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Music } from 'lucide-react';
import { businessInfo } from '../data/mock';

export const Footer = () => {
  return (
    <footer className="bg-page border-t-2 border-green mt-24 relative">
      <div className="absolute inset-0 cyber-grid opacity-30"></div>
      <div className="container mx-auto px-6 py-12 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <img 
              src="/logo.jpeg" 
              alt="The Br8k Room" 
              className="h-16 w-auto mb-4"
              style={{ filter: 'drop-shadow(0 0 10px rgba(0, 255, 65, 0.3))' }}
            />
            <p className="text-secondary text-sm leading-relaxed">
              {businessInfo.tagline}
            </p>
            <p className="text-secondary text-sm mt-4 leading-relaxed">
              7,500 sq ft of pure entertainment. Where reality br8ks and memories are made.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-primary font-bold mb-4 uppercase text-sm tracking-wider" style={{ textShadow: '0 0 5px var(--neon-green)' }}>Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/attractions" className="text-secondary hover:text-blue transition-colors text-sm">Attractions</Link></li>
              <li><Link to="/events" className="text-secondary hover:text-pink transition-colors text-sm">Parties & Events</Link></li>
              <li><Link to="/gallery" className="text-secondary hover:text-blue transition-colors text-sm">Gallery</Link></li>
              <li><Link to="/faq" className="text-secondary hover:text-pink transition-colors text-sm">FAQ</Link></li>
              <li><Link to="/admin" className="text-secondary hover:text-primary transition-colors text-sm">Admin Dashboard</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-blue font-bold mb-4 uppercase text-sm tracking-wider" style={{ textShadow: '0 0 5px var(--neon-blue)' }}>Contact</h3>
            <ul className="space-y-2 text-sm">
              <li className="text-secondary">{businessInfo.address}</li>
              <li>
                <a href={`tel:${businessInfo.phone}`} className="text-secondary hover:text-primary transition-colors">
                  {businessInfo.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${businessInfo.emails[0]}`} className="text-secondary hover:text-primary transition-colors break-all">
                  {businessInfo.emails[0]}
                </a>
              </li>
            </ul>
          </div>

          {/* Hours & Social */}
          <div>
            <h3 className="text-pink font-bold mb-4 uppercase text-sm tracking-wider" style={{ textShadow: '0 0 5px var(--neon-pink)' }}>Hours</h3>
            <ul className="space-y-1 text-sm mb-6">
              <li className="text-secondary">Mon-Thu: {businessInfo.hours.monday}</li>
              <li className="text-secondary">Fri-Sat: {businessInfo.hours.friday}</li>
              <li className="text-secondary">Sunday: {businessInfo.hours.sunday}</li>
            </ul>
            <div className="flex space-x-4">
              <a
                href={businessInfo.social.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary hover:text-blue transition-colors"
                aria-label="Facebook"
                style={{ filter: 'drop-shadow(0 0 5px var(--neon-green))' }}
              >
                <Facebook size={24} />
              </a>
              <a
                href={businessInfo.social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="text-pink hover:text-primary transition-colors"
                aria-label="Instagram"
                style={{ filter: 'drop-shadow(0 0 5px var(--neon-pink))' }}
              >
                <Instagram size={24} />
              </a>
              <a
                href={businessInfo.social.tiktok}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue hover:text-pink transition-colors"
                aria-label="TikTok"
                style={{ filter: 'drop-shadow(0 0 5px var(--neon-blue))' }}
              >
                <Music size={24} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t-2 border-green mt-12 pt-8 text-center">
          <p className="text-secondary text-sm">
            © {new Date().getFullYear()} The Br8k Room. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};